import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { CHAT_STATUS } from '@whatsper/texterchat-common';
import { UserOutlined } from '@ant-design/icons';
import PanelSummary from '../components/PanelSummary';
import { withStore } from '../../../store/rootStore';
import { getHoursAndMinutes } from '../helpers';
import { ReactComponent as UserAdd } from '../../../assets/icons/dashboard/UserAdd.svg';
import { ReactComponent as ClockCircle } from '../../../assets/icons/dashboard/ClockCircle.svg';
import { ReactComponent as Hourglass } from '../../../assets/icons/dashboard/Hourglass.svg';
import { ReactComponent as IssuesClose } from '../../../assets/icons/dashboard/IssuesClose.svg';
import s from '../DashboardDrawer.module.scss';
const Agents = ({ store: { dashboard, agentsStore } }) => {
    const { t } = useTranslation();
    const { [CHAT_STATUS.PENDING]: pending, [CHAT_STATUS.ASSIGNED]: assigned } = dashboard.data;
    const agents = agentsStore.users
        .filter((agent) => !agent.disabled)
        .map((agent) => {
        return Object.assign(Object.assign({}, agent), { isOnline: agentsStore.isUserOnline(agent) });
    })
        // Online agents first, otherwise keep the store order so the table does not jump around
        .sort((a, b) => Number(b.isOnline) - Number(a.isOnline));
    const columns = [
        { icon: React.createElement(UserOutlined, null), title: t('agent') },
        { icon: React.createElement(ClockCircle, null), title: t('pending') },
        { icon: React.createElement(UserAdd, null), title: t('taken') },
        { icon: React.createElement(Hourglass, null), title: t('averagePendingTime') },
        { icon: React.createElement(IssuesClose, null), title: t('averageTimeToResolve') },
    ];
    return (React.createElement("section", null,
        React.createElement("table", { className: classnames(s['main__panel--all'], s['main__panel--rowList']) },
            React.createElement("thead", null,
                React.createElement("tr", null, columns.map(({ icon, title }) => (React.createElement("th", { key: title },
                    React.createElement("div", { className: s['main__tableHeaderCell'] },
                        icon && React.createElement("span", { className: s['main__tableHeaderIcon'] }, icon),
                        React.createElement("span", null, title))))))),
            React.createElement("tbody", null, agents.map(({ displayName, uid, isOnline, color = '#636766' }) => {
                const pendingData = pending === null || pending === void 0 ? void 0 : pending.agents.find((d) => d._id === uid);
                const assignedData = assigned === null || assigned === void 0 ? void 0 : assigned.agents.find((d) => d._id === uid);
                const { chatsCount: totalPending = 0, avgTime: pendingTimeAvgValue } = pendingData || {};
                const { chatsCount: totalTaken = 0, avgTime: takenTimeAvgValue } = assignedData || {};
                const pendingTimeAvg = getHoursAndMinutes(pendingTimeAvgValue);
                const takenTimeAvg = getHoursAndMinutes(takenTimeAvgValue);
                return (React.createElement("tr", { key: uid, className: s['main__panel--row'] },
                    React.createElement("td", { className: s['main__panel--rowTitle'] },
                        React.createElement("div", { className: s['main__panel--agentsHeader'] },
                            React.createElement("span", { className: classnames(s['main__panel--statusDot'], {
                                    [s['main__panel--statusDotMuted']]: !isOnline,
                                }) }),
                            React.createElement("div", { className: s['main__panel--name'], style: { color } }, displayName || uid))),
                    React.createElement(PanelSummary, { panels: [
                            { title: t('pending'), value: totalPending },
                            { title: t('taken'), value: totalTaken },
                            {
                                title: t('averagePendingTime'),
                                value: dashboard.shouldHideOutsideWorkingHours
                                    ? undefined
                                    : pendingTimeAvg,
                            },
                            {
                                title: t('averageTimeToResolve'),
                                value: dashboard.shouldHideOutsideWorkingHours
                                    ? undefined
                                    : takenTimeAvg,
                            },
                        ] })));
            })))));
};
export default withStore(observer(Agents));
